import { proxy } from 'valtio'
import { DateTime } from 'luxon'
import { resetProxy } from './utils.ts'

export interface timezoneType { value: string, offset: number, status: string }
const emptyTz: timezoneType = { value: 'na', offset: 0, status: 'inactive' }

/** Build a timezoneType representing the browser's local timezone */
const getLocalTimezone = (): timezoneType => {
    const zone = DateTime.local().zoneName || 'UTC'
    const offset = DateTime.local().offset / 60
    return { value: zone, offset, status: 'active' }
}

const initialState = {
    user: '',
    token: '',
    userIP: '',
    timezone: emptyTz as timezoneType,
    timezoneOverride: localStorage.getItem('gibi_tz_override') === 'true',
}

export const authState = proxy({ ...initialState })

// --- Action functions ---

export function setTimezoneOverride(v: boolean) {
    localStorage.setItem('gibi_tz_override', String(v))
    authState.timezoneOverride = v
}

export function toggleTimezoneOverride() {
    const next = !authState.timezoneOverride
    localStorage.setItem('gibi_tz_override', String(next))
    authState.timezoneOverride = next
}

/** The effective timezone to use for display — respects the override toggle */
export function effectiveTimezone(): timezoneType {
    if (authState.timezoneOverride) return getLocalTimezone()
    if (!authState.timezone.value || authState.timezone.value === 'na') return getLocalTimezone()
    return authState.timezone
}

export function resetAuth() {
    resetProxy(authState, { ...initialState, timezoneOverride: authState.timezoneOverride })
}

export default authState
